/* eslint-disable no-console */
/* eslint-disable no-useless-call */
import moment from "moment-timezone";

enum Level {
	INFO,
	WARN,
	ERROR,
	DEBUG
}

export class Logger {
	private readonly name: string | undefined;
	private readonly level: Level = Level[process.env.REACT_APP_SENDUM_LOG_LEVEL || "ERROR"] as Level;

	constructor(name?: string) {
		this.name = name;
	}

	private getLine(): number {
		return 0;
	}

	private getPrefix(): string {
		const line = this.getLine();

		if (this.name) {
			return `[${this.name}${line ? ` - ${line}` : ""}]`;
		}

		return "";
	}

	public debug(...args: any[]): void {
		if (this.level === Level.DEBUG) {
			console.debug.apply(console, [moment().format("lll"), this.getPrefix(),...args]);
		}
	}

	public info(...args: any[]): void {
		if (this.level === Level.INFO || this.level === Level.DEBUG) {
			console.info.apply(console, [this.getPrefix(), moment().format("lll"), ...args]);
		}
	}

	public warning(...args: any[]): void {
		if (this.level === Level.WARN || this.level === Level.INFO || this.level === Level.DEBUG) {
			console.warn.apply(console, [this.getPrefix(), moment().format("lll"), ...args]);
		}
	}

	public error(...args: any[]): void {
		console.error.apply(console, [this.getPrefix(), moment().format("lll"), ...args]);
	}
}
